import { type FC, type PropsWithChildren } from "react";

import InternalLink from "./InternalLink";

enum Type {
	PHONE,
	EMAIL,
}

const type2Protocol = {
	[Type.PHONE]: "tel",
	[Type.EMAIL]: "mailto",
};


export type ContactLinkProps = PropsWithChildren<{
	contact: string;
	type: Type;
}>

const ContactLink: FC<ContactLinkProps> = ({ type, contact, children }) => {
	return (
		<InternalLink to={`${type2Protocol[type]}:${contact}`} variant="light">
			{children ?? contact}
		</InternalLink>
	);
}

export type PhoneLinkProps = PropsWithChildren<{
	phone: string;
}>

export const PhoneLink: FC<PhoneLinkProps> = ({ phone, children }) => {
	return (
		<ContactLink contact={phone} type={Type.PHONE}>
			{children}
		</ContactLink>
	);
}

interface EmailLinkProps {
	email: string;
}

export const EmailLink: FC<EmailLinkProps> = ({ email }) => {
	return <ContactLink contact={email} type={Type.EMAIL} />;
}
